import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as Storage from './Storage';
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_SERVER}/api/${uuidv4().replace(/-/g, '')}/`,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});
const refreshToken = async () => {
  try {
    const response = await axiosInstance.get('/refresh-token');
    if (response.data.status === 1000) {
      await Storage.set('accessToken', response.data.data.accessToken);
    }
    return response;
  } catch (error) {
    return false;
  }
};
export default refreshToken;